import { useUserStore } from "@/stores/user";

import { PERMISSION_KEY } from "@/types/user";

export const requiresPermission = (permission: PERMISSION_KEY | PERMISSION_KEY[]): boolean => {
    const userStore = useUserStore()
    if (typeof permission === 'string') {
        return userStore.permission[permission]
    }

    for (const permissionEl of permission) {
        if (!userStore.permission[permissionEl]) return false
    }

    return true
}

export const requiresSinglePermission = (permission: PERMISSION_KEY[]): boolean => {
    const userStore = useUserStore()
    for (const permissionEl of permission) {
        if (userStore.permission[permissionEl]) return true
    }

    return false
}
